import { render, staticRenderFns } from "./LandingAwardList.vue?vue&type=template&id=73b77289&scoped=true"
import script from "./LandingAwardList.vue?vue&type=script&lang=js"
export * from "./LandingAwardList.vue?vue&type=script&lang=js"
import style0 from "./LandingAwardList.vue?vue&type=style&index=0&id=73b77289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b77289",
  null
  
)

export default component.exports